import countries from "../../../data/countries.json";
import { ICountryRegex } from "../../company/models";
import type { TaxEntry } from "./parseTaxEntries";

export const getParsedTaxId = (entry: TaxEntry, countriesRegex: any) => {
  const viewCountry =
    countries.find((c) => c.code === entry.country)?.name || entry.country;

  const regexConfig = countriesRegex[entry.country] as ICountryRegex;
  const regex = regexConfig?.regexp ? new RegExp(regexConfig.regexp) : "";
  const check =
    regex && entry.value ? regex.test(entry.value) : "none";
  return {
    viewCountry,
    example: regexConfig?.example,
    check,
    value: entry.value,
  };
};
